import { Download, FileJson, FileText, FileDown, Images } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { API } from "../../lib/api";

export const ExportMenu = ({ token, tab, tabLabel }) => {
  const base = `${API}/reports/${token}/export`;
  const go = (path) => { window.location.href = `${base}/${path}`; };
  const items = [
    ["export-tab-pdf", FileDown, `Current tab PDF — ${tabLabel}`, `pdf?tab=${tab}`],
    ["export-full-pdf", FileText, "Complete investigation PDF", "pdf?tab=all"],
    ["export-json", FileJson, "Structured JSON", "json"],
    ["export-markdown", FileText, "Blueprint Markdown", "markdown"],
    ["export-evidence", Images, "Screenshots & evidence (.zip)", "evidence"],
  ];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="export-menu-btn" className="flex items-center gap-2 border border-[#d4af37]/60 px-4 py-2.5 font-mono text-xs font-bold uppercase tracking-widest text-[#d4af37] transition-colors hover:bg-[#d4af37] hover:text-black">
          <Download className="h-4 w-4" /> Export
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72 rounded-none border-[#262626] bg-[#0d0d0d] text-white">
        <DropdownMenuLabel className="rea-label">Export intelligence</DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-[#262626]" />
        {items.map(([id, Icon, label, path]) => (
          <DropdownMenuItem key={id} data-testid={id} onClick={() => go(path)} className="cursor-pointer gap-2 rounded-none font-mono text-xs focus:bg-red-950 focus:text-white">
            <Icon className="h-4 w-4 text-red-500" /> {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
